import apiClient from '../../api/apiClient';
import { API_ENDPOINTS } from '../../api/endPoints';
import { EventItem, PaginatedEventsResponse } from '../../types/events.types';

export interface ListEventsParams {
  limit?: number;
  lastEvaluatedKey?: any;
}

export const listEvents = async (params?: ListEventsParams): Promise<PaginatedEventsResponse> => {
  const resp = await apiClient.get(API_ENDPOINTS.PUBLISHER.EVENTS.LIST, {
    params: {
      limit: params?.limit,
      lastEvaluatedKey: params?.lastEvaluatedKey ? JSON.stringify(params.lastEvaluatedKey) : undefined,
    },
  });
  const data = resp.data;
  if (Array.isArray(data)) {
    return { items: data as EventItem[] };
  }
  return {
    items: data?.items ?? [],
    lastEvaluatedKey: data?.lastEvaluatedKey,
  };
};

export const listEventsByWebsite = async (
  websitePK: string,
  params?: { maxEvents?: number; lastEvaluatedKey?: any }
): Promise<PaginatedEventsResponse> => {
  const resp = await apiClient.get(
    API_ENDPOINTS.PUBLISHER.EVENTS.BY_WEBSITE(websitePK),
    {
      params: {
        maxEvents: params?.maxEvents,
        lastEvaluatedKey: params?.lastEvaluatedKey ? JSON.stringify(params.lastEvaluatedKey) : undefined,
      },
    }
  );
  const data = resp.data;
  if (Array.isArray(data)) {
    return { items: data as EventItem[] };
  }
  return {
    items: data?.items ?? [],
    lastEvaluatedKey: data?.lastEvaluatedKey,
  };
};

export const getEventById = async (id: string): Promise<EventItem> => {
  const resp = await apiClient.get(API_ENDPOINTS.PUBLISHER.EVENTS.DETAIL(id));
  return resp.data as EventItem;
};

export const createEvent = async (event: Partial<EventItem>): Promise<EventItem> => {
  const resp = await apiClient.post(API_ENDPOINTS.PUBLISHER.EVENTS.CREATE, event);
  return resp.data as EventItem;
};

export const updateEvent = async (id: string, updates: Partial<EventItem>): Promise<EventItem> => {
  const resp = await apiClient.patch(API_ENDPOINTS.PUBLISHER.EVENTS.UPDATE(id), updates);
  return resp.data as EventItem;
};

export const deleteEvent = async (id: string): Promise<void> => {
  await apiClient.delete(API_ENDPOINTS.PUBLISHER.EVENTS.DELETE(id));
};